export default class VendorTeamName {
  public static get Prototype(): VendorTeamName {
    return new VendorTeamName("Prototype Team Name");
  }  
  public static fromJSON(value: string): VendorTeamName {
    return new VendorTeamName(value);
  }

  constructor(public readonly value: string) { }
  public toJSON(): string {
    return this.value;
  }

  public isEqualTo = (other: VendorTeamName): boolean =>
    this.value === other?.value;

  public clone = (): this => this // Immutable
}
